import Vue from 'vue'

Vue.directive('activateHtmlLinksInInnerText', {
  inserted(e1) {
    if (typeof e1.textContent === 'string') {
      e1.innerHTML = e1.textContent.replaceAll(/ (http[s]?:\/\/[^ )(]*)/g, '<a href="$1" target="_blank">$1</a>');
    }
  }
})

Vue.directive('activateLinksOnWordsInInnerText', {
  inserted(e1) {
    const linksForWords = [
      { word: "SemTab2021", link: "http://www.cs.ox.ac.uk/isg/challenges/sem-tab/"},
      { word: "ISWC2021", link: "https://iswc2021.semanticweb.org/"},
      { word: "Youtube Channel", link: "https://www.youtube.com/channel/UC30pJdIBeskw5fmIBqsn6ZA"},
      { word: "Python", link: "https://www.python.org/"},
      { word: "Flask", link: "https://flask.palletsprojects.com/en/2.0.x/"},
      { word: "Gunicorn", link: "https://gunicorn.org/"},
      { word: "Celery", link: "https://docs.celeryproject.org/en/stable/"},
      { word: "RabbitMQ", link: "https://www.rabbitmq.com/"},
      { word: "ElasticSearch", link: "https://www.elastic.co/fr/"},
      { word: "MongoDB", link: "https://www.mongodb.com/"},
      { word: "ScikitLearn", link: "https://scikit-learn.org/stable/"},
      { word: "Spacy", link: "https://spacy.io/"},
      { word: "DeepPavlov", link: "https://deeppavlov.ai/"},
      { word: "Wikidata", link: "https://www.wikidata.org/"},
      { word: "DBPedia", link: "https://www.dbpedia.org/"},
      { word: "DAGOBAH: Table and Graph Contexts For Efficient Semantic Annotation of Tabular Data", link: "https://github.com/yoanchabot/papers/raw/main/huynh2021.pdf"},
      { word: "A Framework for Automatically Interpreting Tabular Data at Orange", link: "https://github.com/yoanchabot/papers/raw/main/chabot2021b.pdf"},
      { word: "DAGOBAH: Enhanced Scoring Algorithms for Scalable Annotations of Tabular Data", link: "https://github.com/yoanchabot/papers/raw/main/huynh2020a.pdf"},
      { word: "DAGOBAH : Un système d’annotation sémantique de données tabulaires indépendant du contexte", link: "https://github.com/yoanchabot/papers/raw/main/chabot2020b.pdf"},
      { word: "DAGOBAH: An End-to-End Context-Free Tabular Data Semantic Annotation System", link: "https://github.com/yoanchabot/papers/raw/main/chabot2019a.pdf"},
      { word: "DAGOBAH: Tables, AI will understand", link: "https://imtech.wp.imt.fr/en/2020/10/19/dagobah-tables-ai-will-understand/"},
      { word: "DAGOBAH: Make Tabular Data Speak Great Again", link: "https://hellofuture.orange.com/en/dagobah-make-tabular-data-speak-great-again/"},
    ];
    if (typeof e1.textContent === 'string') {
      let textContent = e1.textContent;
      linksForWords.forEach((linkForWord) => {
        textContent = textContent.replaceAll(linkForWord.word, `<a href="${linkForWord.link}" target="_blank">${linkForWord.word}</a>`);
      });
      e1.innerHTML = textContent;
    }
  }
})
